import { takeLatest, put, call, select } from 'redux-saga/effects';
import { SEND_BOOKING_SAGA } from "../sagaTypes";
import { loadingAction } from '../actions.js';
import { url } from "../../config";
import growl from "../../lib/growl/growl.js";
import { authAction } from "../actions";
import { getBookingSagaAction } from "../sagaActions";
import { AUTH_FORM_INITIAL } from "../initialStateConstants";

const request = data => {
    return fetch(`${ url }/send_booking`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerSendBooking(args) {
    const booking = yield select(state => state.booking);
    const est = yield select(state => state.est);

    yield put(loadingAction(true));
    try {
        let formData = new FormData();
        formData.append('booking_id', args.data?.booking_id);
        formData.append('email', args.data?.email);
        formData.append('password', args.data?.password);

        if (est.slug && est.id) {
            formData.append('slug', est.slug);
            formData.append('est', est.id);
        }

        const response = yield call (request, formData);

        if (response.success) {
            // Закрываем форму авторизации
            yield put(authAction(AUTH_FORM_INITIAL));
            // Запрашиваем записи на текущий день
            yield put(getBookingSagaAction({ date: booking.date }));
            growl({ type: 'success', message: response.message });
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loadingAction(false));
    }
    finally {
        yield put(loadingAction(false));
    }
}

export default function* watcherSendBooking() {
    yield takeLatest(SEND_BOOKING_SAGA, workerSendBooking);
}